<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form :inline="true">
          <el-form-item label="每日获得体力上限">
            <el-input v-model.number="config.maxSendSpin" placeholder="每日获得体力上限" />
          </el-form-item>
          <el-form-item label="每日获得金币上限">
            <el-input v-model.number="config.maxSendCoin" placeholder="每日获得金币上限" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="setMaxLimit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <abnormalUserStat />

      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <!--          <el-form-item label="用户ID" prop="type">-->
          <!--            <el-input-->
          <!--              v-model.number="queryParams.uid"-->
          <!--              placeholder="请输入用户ID"-->
          <!--              clearable-->
          <!--              size="small"-->
          <!--              @keyup.enter.native="handleQuery"-->
          <!--            />-->
          <!--          </el-form-item>-->

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>
        <div slot="header" class="clearfix">
          <span>用户消耗列表</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            prop="obtain_spin"
            label="获得体力"
            align="center"
          />

          <!--          <el-table-column-->
          <!--            prop="cost_spin"-->
          <!--            label="消耗体力"-->
          <!--            align="center"-->
          <!--          />-->

          <el-table-column
            prop="obtain_coin"
            label="获得金币"
            align="center"
          />

          <!--          <el-table-column-->
          <!--            prop="cost_coin"-->
          <!--            label="消耗金币"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="obtain_card"-->
          <!--            label="获取卡片数量"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="cost_card"-->
          <!--            label="消耗卡片数量"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="spin_times"-->
          <!--            label="转动次数"-->
          <!--            align="center"-->
          <!--          />-->

          <!--          <el-table-column-->
          <!--            prop="stock_coin"-->
          <!--            label="金币存量"-->
          <!--            align="center"-->
          <!--          />-->
          <!--          <el-table-column-->
          <!--            prop="stock_spin"-->
          <!--            label="体力存量"-->
          <!--            align="center"-->
          <!--          />-->
        </el-table>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables()"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { exportUserStatList, getMaxLimit, getUserTotalStat, setMaxLimit } from '@/api/user/user_info'
import abnormalUserStat from '@/views/config/user/components/abnormal_user_stat.vue'
import AbnormalUserStat from '@/views/config/user/components/abnormal_user_stat.vue'
export default {
  name: 'UserDayStat',
  components: { AbnormalUserStat },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        type: -1,
        order: '',
        startDate: '',
        endDate: ''
      },
      config: {
        maxSendSpin: 0,
        maxSendCoin: 0
      },
      ordersList: [],
      tableData: []
    }
  },
  created() {
    this.getTables()
    this.getMaxLimit()
  },
  methods: {
    actUid(uid) {
      this.$router.push({ name: 'User', query: { uid: uid }})
    },
    getMaxLimit() {
      getMaxLimit().then(res => {
        if (res.code === 200) {
          this.config.maxSendSpin = res.data.data.MaxSendSpin
          this.config.maxSendCoin = res.data.data.MaxSendCoin
        }
      })
    },
    setMaxLimit() {
      setMaxLimit({ coins: this.config.maxSendCoin, spins: this.config.maxSendSpin }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getMaxLimit()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables()
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables() {
      getUserTotalStat(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list.data
          this.total = res.data.count
          this.queryParams.startDate = res.data.list.req.startDate
          this.queryParams.endDate = res.data.list.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择日期')
        return
      }
      exportUserStatList({ startDate: this.queryParams.startDate }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
